import { mapGetters } from 'vuex';
import profile from '@/components/account/profile/profile.vue';
import contentHeader from '@/components/generics/content-header/content-header.vue';

export default {
  components: {
    contentHeader,
    profile,
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapGetters('user', ['isLoggedIn']),
    gridRowModifier() {
      return {
        row: this.isLayoutMobile,
        'row-x': !this.isLayoutMobile,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/support/support/support.js